import { useQuery } from "@tanstack/react-query";
import { useAccountID } from "./account";
import { useShowID } from "./show";
import axios from "axios";

export const useTopCountries = () => {
    const accountID = useAccountID();
    const showID = useShowID();
    return useQuery({
        queryKey: ["topCountries", accountID, showID],
        queryFn: () =>
            axios.get(`/api/${accountID}/metrics/shows/${showID}/top-countries`).then(res => res.data)
    });
};
